<template>
  <div>
    <page-heading :title="`${appName} Settings`" :loading="fetching"></page-heading>

    <content-placeholder v-if="fetching || !app">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <div v-else>
      <div v-if="app.machine_name === 'timeclock'">
        <timeclock-settings key="timeclockSettings" :app="app"></timeclock-settings>
      </div>
      <div v-else-if="app.machine_name === 'ticketing_system'">
        <ticketing-system-settings key="ticketingSystemSettings" :app="app"></ticketing-system-settings>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import TimeclockSettings from '@/components/app/TimeclockSettings';
  import TicketingSystemSettings from '@/components/app/TicketingSystemSettings';

  export default {
    name: 'AppSettingsPage',
    components: {
      timeclockSettings: TimeclockSettings,
      ticketingSystemSettings: TicketingSystemSettings,
    },
    created() {
      this.$store.dispatch('entities/apps/fetchSingleApp', { id: this.appId });
    },
    data() {
      return {
        translationPrefix: 'pages.appSettings',
        appId: this.$router.currentRoute.params.id,
      };
    },
    computed: {
      ...mapGetters('entities/apps', ['fetching']),

      app() {
        return this.$store.getters['entities/apps/query']()
          .with('roles')
          .with('user_memberships.role')
          .first(this.appId);
      },
      appName() {
        return this.app ? this.app.name : '...';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/AppSettings.vue